

export const LOAD_ROLES = "LOAD_USERS";
export const LOAD_ROLES_SUCCESS = "LOAD_USERS_SUCCESS";
export const TRANSFORM_ROLES = "TRANSFORM_ROLES";
export const SELECT_GROUP = "SELECT_GROUP";

export interface RolesState {
    loading: boolean
    loadingRoles: boolean
    roles: Array<Role>
    rolesGrouped: any,
    selectedGroup: any
    selectedGroupName: string
}

export interface Role {
    GroupName: string
    Description?: string
    UserPoolId: string
    url: string
    LastModifiedDate: string
    CreationDate: boolean
    prettyName?: string
}


interface LoadRoles {
    type: typeof LOAD_ROLES_SUCCESS | typeof LOAD_ROLES | typeof TRANSFORM_ROLES,
    payload: Array<Role>
}

interface SelectGroup {
    type: typeof SELECT_GROUP
    payload: any
}

export type RolesActionTypes = LoadRoles | SelectGroup;
